import { useEffect, useState } from 'react';
import { globalAppService } from '../appService';

// Get a jump on Initializing the globalAppService.
(async () => {
  await globalAppService();
})();

const useGlobalAppService = () => {
  const [hookState, setHookState] = useState({
    isReady: false,
    appService: null,
  });

  useEffect(() => {
    const init = async () => {
      const appService = await globalAppService();
      setHookState({
        isReady: true,
        appService,
      });
    };
    init();
  }, []);

  // TODO: Consider making global event listeners and binding them here.

  return [hookState.isReady, hookState.appService];
};

export default useGlobalAppService;
